import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

import { FormatPipe } from '@softline/ui-core';
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'soft-field-ok-fibper-list-view',
  imports: [
    FormatPipe
  ],
  templateUrl: './fibper.list-view.html',
  styleUrls: ['./fibper.list-view.css'] })
export class FibperListView implements FieldOkItemComponent<any> {
  readonly item = input<any>();
}
